import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useRecentComment, useSendComments } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";

function SendComment({ case_id, comment, setComment }) {
  const { fetchRecentCommentData } = useRecentComment();
  const { sendComment } = useSendComments();
  const { setToaster } = useToast();

  useEffect(() => {
    fetchRecentCommentData(case_id);
  }, [case_id]);

  const handleSendComment = async () => {
    await sendComment(case_id, comment, setToaster);
    fetchRecentCommentData(case_id);
    setComment("");
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSendComment();
    }
  };

  return (
    <div>
      <div className="d-flex gap-2 p-2 mt-n2 mx-n2 rounded w-100">
        <textarea
          rows={1}
          style={{ minHeight: "4rem", maxHeight: "8rem" }}
          type="text"
          className="w-100 p-2 ms-2 rounded"
          placeholder="Add Comment"
          value={comment}
          onChange={(event) => {
            setComment(event.target.value);
          }}
        />
        <Button
          size="sm"
          onClick={handleSendComment}
          style={{ height: "2.6rem" }}
        >
          Send
        </Button>
      </div>
    </div>
  );
}

export default SendComment;
